
import { useState, useEffect, useRef } from 'react';

const services = [
  {
    id: 1,
    title: 'Brand Development & Strategic Positioning',
    shortTitle: 'Branding',
    icon: 'ri-palette-line',
    color: '#038C7F',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20brand%20strategy%20workshop%20with%20creative%20team%20developing%20visual%20identity%20modern%20office%20environment%20brand%20guidelines%20mood%20boards%20color%20palettes%20typography%20samples%20strategic%20planning%20session%20collaborative%20atmosphere%20premium%20quality%20photography%20warm%20tones&width=800&height=600&seq=svc-brand-010&orientation=landscape',
    description:
      'We conduct brand audits, competitive analysis, market positioning, messaging development, and visual identity design. A strong brand reduces market confusion, builds recognition, and aligns perception with business objectives.',
    items: [
      {
        icon: 'ri-compass-3-line',
        title: 'Brand Strategy & Audits',
        desc: 'Competitive analysis and market positioning',
      },
      {
        icon: 'ri-pencil-ruler-2-line',
        title: 'Visual Identity Design',
        desc: 'Logo development, brand books & guidelines',
      },
      {
        icon: 'ri-text',
        title: 'Messaging Architecture',
        desc: 'Typography, visual systems & brand voice',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Brand Equity Management',
        desc: 'Long-term credibility and recognition',
      },
    ],
  },
  {
    id: 2,
    title: 'Digital Communication & Online Presence',
    shortTitle: 'Digital',
    icon: 'ri-global-line',
    color: '#F2780C',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20digital%20marketing%20workspace%20with%20multiple%20screens%20showing%20website%20designs%20social%20media%20dashboards%20analytics%20professional%20team%20working%20on%20digital%20campaigns%20contemporary%20office%20setting%20creative%20atmosphere%20premium%20quality%20photography%20warm%20lighting&width=800&height=600&seq=svc-digital-010&orientation=landscape',
    description:
      'We design professional websites, manage social media ecosystems, execute digital campaigns, and develop SEO-informed content strategies. Digital platforms are credibility platforms that strengthen trust and engagement.',
    items: [
      {
        icon: 'ri-window-line',
        title: 'Web Development',
        desc: 'Responsive websites & e-commerce platforms',
      },
      {
        icon: 'ri-smartphone-line',
        title: 'Social Media Management',
        desc: 'Strategy, content production & community growth',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Digital Campaigns',
        desc: 'Conversion-focused UX and campaign management',
      },
      {
        icon: 'ri-search-line',
        title: 'SEO & Content Strategy',
        desc: 'Search optimization and strategic content',
      },
    ],
  },
  {
    id: 3,
    title: 'Film, Media & Public Relations',
    shortTitle: 'Media',
    icon: 'ri-film-line',
    color: '#038C7F',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20film%20production%20set%20with%20cinema%20cameras%20lighting%20equipment%20crew%20filming%20corporate%20documentary%20modern%20production%20studio%20cinematic%20atmosphere%20high%20end%20equipment%20premium%20quality%20photography%20dramatic%20lighting&width=800&height=600&seq=svc-film-010&orientation=landscape',
    description:
      'We produce corporate films, commercials, and documentaries while supporting media engagement strategies. Through strategic narrative management, we position organizations as credible, influential, and forward-looking.',
    items: [
      {
        icon: 'ri-movie-2-line',
        title: 'Corporate Films & Docs',
        desc: 'Full-scale production from concept to post',
      },
      {
        icon: 'ri-clapperboard-line',
        title: 'Commercials & Digital Ads',
        desc: 'TV, online, and promotional campaigns',
      },
      {
        icon: 'ri-quill-pen-line',
        title: 'Scriptwriting & Narrative',
        desc: 'Strategic messaging and brand positioning',
      },
      {
        icon: 'ri-newspaper-line',
        title: 'Media & PR Support',
        desc: 'Regional media placements and communication',
      },
    ],
  },
  {
    id: 4,
    title: 'Traditional Advertising & Physical Visibility',
    shortTitle: 'Outdoor',
    icon: 'ri-billboard-line',
    color: '#F2780C',
    image:
      'https://readdy.ai/api/search-image?query=Large%20format%20billboard%20advertising%20on%20major%20highway%20urban%20landscape%20modern%20city%20skyline%20professional%20outdoor%20advertising%20installation%20vehicle%20branding%20fleet%20premium%20quality%20photography%20clear%20sky%20vibrant%20warm%20colors%20golden%20hour&width=800&height=600&seq=svc-outdoor-010&orientation=landscape',
    description:
      'We execute billboard campaigns, vehicle branding, and high-quality printed materials. Physical advertising reinforces brand recall and signals scale, professionalism, and permanence.',
    items: [
      {
        icon: 'ri-road-map-line',
        title: 'Billboard Campaigns',
        desc: 'Design, production & placement across East Africa',
      },
      {
        icon: 'ri-car-line',
        title: 'Vehicle Branding',
        desc: 'Full and partial wraps for corporate fleets',
      },
      {
        icon: 'ri-printer-line',
        title: 'Print Production',
        desc: 'Brochures, marketing collateral & event materials',
      },
      {
        icon: 'ri-building-line',
        title: 'Physical Brand Presence',
        desc: 'Signage and permanent brand installations',
      },
    ],
  },
  {
    id: 5,
    title: 'Garment Manufacturing & Wearable Branding',
    shortTitle: 'Garments',
    icon: 'ri-t-shirt-line',
    color: '#038C7F',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20garment%20manufacturing%20facility%20with%20branded%20corporate%20uniforms%20quality%20textile%20production%20modern%20factory%20setting%20organized%20workspace%20premium%20apparel%20production%20professional%20atmosphere%20clean%20environment%20warm%20lighting&width=800&height=600&seq=svc-garment-010&orientation=landscape',
    description:
      'We produce corporate uniforms and promotional apparel aligned with brand identity standards. Branded garments function as mobile advertising assets that enhance visibility and consistency.',
    items: [
      {
        icon: 'ri-user-star-line',
        title: 'Corporate Uniforms',
        desc: 'Professional, durable, brand-aligned apparel',
      },
      {
        icon: 'ri-gift-line',
        title: 'Promotional Merchandise',
        desc: 'T-shirts, event wear & branded collections',
      },
      {
        icon: 'ri-stack-line',
        title: 'Bulk Manufacturing',
        desc: 'International standards, regional delivery',
      },
      {
        icon: 'ri-price-tag-3-line',
        title: 'Wearable Brand Assets',
        desc: 'Mobile advertising and visibility enhancement',
      },
    ],
  },
  {
    id: 6,
    title: 'Content Strategy & Reputation Management',
    shortTitle: 'Content',
    icon: 'ri-article-line',
    color: '#F2780C',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20content%20creation%20workspace%20with%20writers%20and%20strategists%20developing%20articles%20blogs%20institutional%20profiles%20modern%20office%20environment%20collaborative%20atmosphere%20premium%20quality%20photography%20creative%20workspace%20warm%20tones&width=800&height=600&seq=svc-content-010&orientation=landscape',
    description:
      'We develop thought-leadership articles, blogs, institutional profiles, and strategic narratives designed to improve public image, strengthen credibility, attract investors, and grow markets.',
    items: [
      {
        icon: 'ri-lightbulb-line',
        title: 'Thought Leadership',
        desc: 'Articles and insights that position expertise',
      },
      {
        icon: 'ri-file-text-line',
        title: 'Institutional Profiles',
        desc: 'Company profiles and annual reports',
      },
      {
        icon: 'ri-chat-quote-line',
        title: 'Strategic Narratives',
        desc: 'Reputation management and public image',
      },
      {
        icon: 'ri-presentation-line',
        title: 'Corporate Communications',
        desc: 'Investor presentations and PR materials',
      },
    ],
  },
];

export default function Services() {
  const [activeService, setActiveService] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  // IntersectionObserver to trigger entrance animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Guard against rapid clicks while a transition is in progress
  const handleServiceChange = (index: number) => {
    if (index === activeService || isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveService(index);
      setIsTransitioning(false);
    }, 250);
  };

  const current = services[activeService];

  return (
    <section
      ref={sectionRef}
      id="services"
      className="relative py-16 sm:py-20 lg:py-28 bg-white overflow-hidden"
    >
      {/* Background gradients */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-gradient-to-br from-[#038C7F]/[0.03] to-transparent rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-gradient-to-tl from-[#F2780C]/[0.03] to-transparent rounded-full blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section header */}
        <div
          className={`text-center mb-10 sm:mb-14 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#F2780C]/10 rounded-full mb-4">
            <i className="ri-service-line text-[#F2780C] text-sm"></i>
            <span className="text-[10px] sm:text-xs font-bold tracking-[0.2em] text-[#F2780C] uppercase">
              Core Expertise
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0D0D0D] leading-tight mb-3">
            Integrated Advertising{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#038C7F] to-[#F2780C]">
              Architecture
            </span>
          </h2>
          <p className="text-sm sm:text-base text-gray-500 max-w-2xl mx-auto">
            Full-spectrum execution from strategy to production. Every communication element
            reinforces a unified brand narrative.
          </p>
        </div>

        {/* Service navigation (pill tabs) */}
        <div
          className={`mb-10 sm:mb-14 transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {services.map((service, index) => (
              <button
                key={service.id}
                onClick={() => handleServiceChange(index)}
                className={`group flex items-center gap-2 px-4 sm:px-5 py-2.5 sm:py-3 rounded-full transition-all duration-400 whitespace-nowrap cursor-pointer ${
                  activeService === index
                    ? 'bg-[#0D0D0D] text-white shadow-xl shadow-black/10 scale-105'
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100 border border-gray-100'
                }`}
              >
                <div
                  className={`w-7 h-7 rounded-lg flex items-center justify-center transition-all ${
                    activeService === index ? 'bg-white/15' : 'bg-white'
                  }`}
                >
                  <i
                    className={`${service.icon} text-sm ${
                      activeService === index ? 'text-white' : 'text-gray-500'
                    }`}
                  ></i>
                </div>
                <span className="text-xs sm:text-sm font-semibold hidden sm:inline">
                  {service.shortTitle}
                </span>
                <span className="text-xs font-semibold sm:hidden">{service.shortTitle}</span>
                {activeService === index && (
                  <span className="w-1.5 h-1.5 bg-[#038C7F] rounded-full animate-pulse ml-1"></span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Active service showcase */}
        <div className={`transition-opacity duration-250 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-14 items-stretch">
            {/* Left side – image + overlay */}
            <div className="relative group">
              <div className="absolute -inset-3 bg-gradient-to-br from-[#038C7F]/10 to-[#F2780C]/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="relative h-full min-h-[280px] sm:min-h-[360px] lg:min-h-[460px] rounded-2xl overflow-hidden">
                <img
                  src={current.image}
                  alt={current.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/80 via-[#0D0D0D]/20 to-transparent" />
                {/* Service number */}
                <div className="absolute top-5 left-5 flex items-center gap-3">
                  <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-xl">
                    <span className="text-2xl font-black text-[#0D0D0D]">0{current.id}</span>
                  </div>
                  <div className="px-3 py-1.5 bg-white/15 backdrop-blur-md rounded-full">
                    <span className="text-[10px] font-bold text-white uppercase tracking-wider">
                      {current.shortTitle}
                    </span>
                  </div>
                </div>
                {/* Bottom gradient info */}
                <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-7">
                  <div className="flex items-center gap-3 mb-2">
                    <div
                      className="w-9 h-9 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${current.color}30` }}
                    >
                      <i className={`${current.icon} text-lg text-white`}></i>
                    </div>
                    <span className="text-xs font-bold text-white/60 uppercase tracking-wider">
                      Äsili Visuals
                    </span>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-white leading-tight">{current.title}</h3>
                </div>
              </div>
            </div>

            {/* Right side – textual content */}
            <div className="flex flex-col justify-center">
              {/* Title & description */}
              <div className="mb-6 sm:mb-8">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${current.color}15` }}
                  >
                    <i className={`${current.icon} text-xl`} style={{ color: current.color }}></i>
                  </div>
                  <div>
                    <span
                      className="text-[10px] font-bold uppercase tracking-wider"
                      style={{ color: current.color }}
                    >
                      Service 0{current.id}
                    </span>
                    <h3 className="text-lg sm:text-xl font-black text-[#0D0D0D] leading-tight">
                      {current.title}
                    </h3>
                  </div>
                </div>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{current.description}</p>
              </div>

              {/* Capability cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6 sm:mb-8">
                {current.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="group/card flex items-start gap-3 p-3.5 bg-gray-50 rounded-xl hover:bg-white hover:shadow-lg hover:shadow-gray-100 border border-transparent hover:border-gray-100 transition-all duration-300 cursor-default"
                  >
                    <div
                      className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors duration-300 group-hover/card:scale-110"
                      style={{ backgroundColor: `${current.color}12` }}
                    >
                      <i className={`${item.icon} text-sm`} style={{ color: current.color }}></i>
                    </div>
                    <div className="min-w-0">
                      <h4 className="text-xs sm:text-sm font-bold text-[#0D0D0D] mb-0.5">{item.title}</h4>
                      <p className="text-[10px] sm:text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Call‑to‑action */}
              <div className="flex items-center gap-4">
                <a
                  href="#contact"
                  className="group inline-flex items-center gap-3 px-6 py-3 bg-[#0D0D0D] text-white text-sm font-semibold rounded-full hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>Get Started</span>
                  <div className="w-7 h-7 bg-white/15 rounded-full flex items-center justify-center group-hover:bg-[#038C7F] transition-colors">
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
                <a
                  href="#portfolio"
                  className="text-sm font-semibold text-gray-500 hover:text-[#038C7F] transition-colors cursor-pointer flex items-center gap-1.5"
                >
                  <span>See Work</span>
                  <i className="ri-arrow-right-up-line text-base"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom grid – quick service access */}
        <div
          className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mt-12 sm:mt-16 transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {services.map((service, index) => (
            <div
              key={`grid-${service.id}`}
              onClick={() => handleServiceChange(index)}
              className={`group relative p-4 rounded-xl cursor-pointer transition-all duration-300 text-center ${
                activeService === index
                  ? 'bg-[#0D0D0D] shadow-xl scale-[1.03]'
                  : 'bg-gray-50 hover:bg-gray-100 border border-gray-100'
              }`}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-3 transition-all ${
                  activeService === index ? 'bg-white/15' : ''
                }`}
                style={{
                  backgroundColor: activeService === index ? undefined : `${service.color}10`,
                }}
              >
                <i
                  className={`${service.icon} text-lg ${activeService === index ? 'text-white' : ''}`}
                  style={{
                    color: activeService === index ? undefined : service.color,
                  }}
                ></i>
              </div>

              <div
                className={`text-[10px] font-bold mb-1 ${
                  activeService === index ? 'text-white/50' : 'text-gray-400'
                }`}
              >
                0{service.id}
              </div>
              <h4
                className={`text-xs font-bold leading-tight ${
                  activeService === index ? 'text-white' : 'text-[#0D0D0D]'
                }`}
              >
                {service.shortTitle}
              </h4>

              {activeService === index && (
                <div className="absolute top-2.5 right-2.5 w-2 h-2 bg-[#038C7F] rounded-full animate-pulse"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
